import React from "react";
import WindowContainer from "../../common/WindowContainer";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <div id="contactSection" className="flex flex-col items-center ">
      <span className="text-3xl text-center lg:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
        Want to collaborate?
      </span>
      <span className="text-2xl lg:text-4xl mb-10 font-extralight text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
        Get in touch!
      </span>
      <WindowContainer>
        <ContactForm />
      </WindowContainer>
    </div>
  );
};

export default Contact;
